import { Image, Radio, Spin } from 'antd';
import { TDataRequest } from '../request';
import CustomCheckbox from '../../../../components/checkbox';
import { Rate, ShippingAddress, StorageItem } from '../../../../apis/client-axios';
import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';

type TProps = {
  dataRequest: TDataRequest;
  setDataRequest: React.Dispatch<React.SetStateAction<TDataRequest>>;
  itemDetail: AxiosResponse<StorageItem, any>;
  modalEditAddress: {
    isOpen: boolean;
    isChange: boolean;
    data: Omit<ShippingAddress, 'AddressID' | 'AddressOwner' | 'CountryName'>;
  };
  carrier: Rate[];
  loadingCarrier: boolean;
};

const Carrier = ({ dataRequest, setDataRequest, modalEditAddress, carrier, loadingCarrier }: TProps) => {
  useEffect(() => {
    if (!carrier || Object.values(carrier).length === 0) return;

    // Kiểm tra xem provider đã chọn còn trong list hay không
    const matchedCarrier = Object.values(carrier).find((item) => item?.provider === dataRequest.carrier);

    if (matchedCarrier) {
      // Nếu provider đang chọn quay trở lại, cập nhật lại thông tin
      setDataRequest((prev) => ({
        ...prev,
        carrierPrice: +matchedCarrier?.amount,
        shippingPlan: matchedCarrier?.servicelevel['displayName'] ?? matchedCarrier?.servicelevel['name'],
        shippingRate: matchedCarrier?.objectId,
      }));
    } else {
      setDataRequest((prev) => ({
        ...prev,
        carrierPrice: 0,
        shippingPlan: '',
        shippingRate: '',
        isPickUPSOutSide: false,
      }));
    }
  }, [carrier]);

  return (
    <>
      <div className="box box-carrier">
        <div className="title">
          <h3>配送会社</h3>
          <span className="title-required">*</span>
        </div>
        <div className="list-info content-partitions">
          <Radio.Group value={dataRequest.carrier}>
            <div className="carrier">
              {carrier
                ? Object.values(carrier)
                    .filter((v: Rate) => (dataRequest.confirm ? v?.provider === dataRequest.carrier : v))
                    .map((item, index) => (
                      <label
                        className={`carrier-item ${dataRequest.carrier === item.provider && 'active'} ${dataRequest.confirm && 'disabled'}`}
                        key={index}
                      >
                        <Radio
                          disabled={dataRequest.confirm}
                          value={item?.provider}
                          id={item?.provider}
                          onChange={() => {
                            const isUPSOutsideUS = item?.provider === 'UPS' && modalEditAddress.data.Country !== 'US';

                            setDataRequest({
                              ...dataRequest,
                              carrier: item.provider,
                              carrierPrice: +item?.amount,
                              shippingPlan: item.servicelevel['displayName'] ?? item.servicelevel['name'],
                              shippingRate: item.objectId,
                              isPickUPSOutSide: isUPSOutsideUS,
                            });
                          }}
                        />
                        <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                          <Image
                            preview={false}
                            width={64}
                            src={`/assets/icons/carrier/${item?.provider?.toLowerCase()}.png`}
                          />
                          <div>
                            <span className="name">{item?.provider}</span>
                            <div>
                              <span className="price">${item?.amount}</span>
                            </div>
                            <div className="font-base color-sub-title font-weight-500 font-size-12 m-t-4 text-overflow-130">
                              {item?.servicelevel['displayName'] ?? item?.servicelevel['name']}
                            </div>
                            <div className="font-base color-cancel font-weight-500 font-size-10 m-t-2">
                              お届け日数：{item?.estimatedDays}
                            </div>
                          </div>
                        </div>
                      </label>
                    ))
                : null}
            </div>
          </Radio.Group>
          {(dataRequest.confirm && dataRequest.isInsurance) || !dataRequest.confirm ? (
            <>
              <div className="insurance">
                <div className="insurance_wp">
                  {!dataRequest.confirm ? (
                    <CustomCheckbox
                      className="insurance_item_checkbox"
                      checked={dataRequest.isInsurance}
                      onChange={({ target: { checked } }) => {
                        setDataRequest((prev) => ({
                          ...prev,
                          isInsurance: checked,
                        }));
                      }}
                      disabled={dataRequest.confirm}
                    />
                  ) : (
                    <div></div>
                  )}
                  <label>保険料</label>
                  <span className="colon">:</span>
                  <div className="insurance_item_price">${dataRequest.insurance}</div>
                </div>
              </div>
            </>
          ) : (
            <div className="content-partitions"></div>
          )}
        </div>
      </div>
    </>
  );
};

export default Carrier;
